import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
// Import both versions
import IconTileNew from './icon-tile-new';
import IconTileOld from './icon-tile-old';

// Color mapping for size 16 standalone icons that will no longer be tiles
var appearanceToIconColorMap = {
  blue: "var(--ds-icon-accent-blue, #1D7AFC)",
  blueBold: "var(--ds-icon-accent-blue, #1D7AFC)",
  gray: "var(--ds-icon-accent-gray, #758195)",
  grayBold: "var(--ds-icon-accent-gray, #758195)",
  green: "var(--ds-icon-accent-green, #22A06B)",
  greenBold: "var(--ds-icon-accent-green, #22A06B)",
  lime: "var(--ds-icon-accent-lime, #6A9A23)",
  limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
  magenta: "var(--ds-icon-accent-magenta, #CD519D)",
  magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
  orange: "var(--ds-icon-accent-orange, #E56910)",
  orangeBold: "var(--ds-icon-accent-orange, #E56910)",
  purple: "var(--ds-icon-accent-purple, #8270DB)",
  purpleBold: "var(--ds-icon-accent-purple, #8270DB)",
  red: "var(--ds-icon-accent-red, #C9372C)",
  redBold: "var(--ds-icon-accent-red, #C9372C)",
  teal: "var(--ds-icon-accent-teal, #2898BD)",
  tealBold: "var(--ds-icon-accent-teal, #2898BD)",
  yellow: "var(--ds-icon-accent-yellow, #B38600)",
  yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};

/**
 * __IconTile__
 *
 * An icon with background shape, color, and size properties determined by Tile.
 */
export default function IconTile(_ref) {
  var appearance = _ref.appearance,
    Icon = _ref.icon,
    label = _ref.label,
    size = _ref.size,
    testId = _ref.testId,
    shape = _ref.shape,
    LEGACY_fallbackComponent = _ref.LEGACY_fallbackComponent,
    UNSAFE_circleReplacementComponent = _ref.UNSAFE_circleReplacementComponent;
  // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
  if (LEGACY_fallbackComponent && !fg('platform-visual-refresh-icons')) {
    return LEGACY_fallbackComponent;
  }
  if (UNSAFE_circleReplacementComponent && shape === 'circle' && fg('platform_dst_icon_tile_circle_replacement')) {
    return UNSAFE_circleReplacementComponent;
  }
  if (shape !== 'circle' && fg('platform_dst_new_icon_tile')) {
    // Handle size 16 - render icon directly without Tile
    if (size === '16') {
      return /*#__PURE__*/React.createElement(Icon, {
        color: appearanceToIconColorMap[appearance],
        label: label,
        testId: testId
      });
    }
    return /*#__PURE__*/React.createElement(IconTileNew, {
      appearance: appearance,
      icon: Icon,
      label: label,
      shape: shape,
      size: size,
      testId: testId
    });
  }
  return /*#__PURE__*/React.createElement(IconTileOld, {
    appearance: appearance,
    icon: Icon,
    label: label,
    shape: shape,
    size: size,
    testId: testId
  });
}